export default "__VITE_ASSET__BAj8Ukl8__"